export default "__VITE_ASSET__BukD7Xxh__"